import React from 'react';
import Footer from './Footer';

export default function EmpateaFooter() {
  return (
    <div className="bg-white">
      <Footer />
    </div>
  );
}
